import React from "react";
import { Box, Typography } from "@mui/material";
import { Icon, T } from "./signupDesign";

const NEEDED = [
  "Your EIN (Federal Tax ID) and business start date",
  "Name, date of birth, SSN, home address and driver's license number for each owner with 25% or more",
  "A photo or scan of each owner's driver's license or ID",
  "A voided check or bank letter for your payout account",
  "Any one of: your business license, IRS EIN letter, or food service / health permit",
];

/** Shown once the applicant has started, at the top of the first step. */
export default function WhatYouNeed() {
  return (
    <Box sx={{ background: T.footerBg, border: `1px solid ${T.cardBorder}`, borderRadius: "16px", p: { xs: 2, sm: 2.5 }, mb: 3 }}>
      <Typography component="h3" sx={{ fontWeight: 700, fontSize: 17, color: T.text, mb: 1.5 }}>What you'll need</Typography>
      <Box component="ul" sx={{ listStyle: "none", m: 0, p: 0, display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, columnGap: 3 }}>
        {NEEDED.map((t) => (
          <Box component="li" key={t} sx={{ display: "flex", gap: 1.25, mb: 1.25 }}>
            <Box sx={{ color: T.green, mt: "2px" }}><Icon.Check size={18} /></Box>
            <Typography sx={{ color: T.text2, fontSize: 15, lineHeight: 1.55 }}>{t}</Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ color: T.hint, fontSize: 14, mt: 0.5, lineHeight: 1.55, display: "flex", gap: 0.75, alignItems: "flex-start" }}>
        <Box component="span" sx={{ mt: "2px" }}><Icon.Lock size={14} /></Box>
        <span>Our payment processors are required by law to verify every merchant and its owners. Everything you enter is encrypted.</span>
      </Typography>
    </Box>
  );
}
